import { HttpContextToken } from '@angular/common/http';
import { StateToken } from '@ngxs/store';
import {
  AuthStateModel,
  DashboardStateModel,
  EstablishmentStateModel,
  GlobalStateModel,
  InvoiceStateModel,
  ResourceStateModel,
  StickerConsumptionStateModel
} from '~backoffice/app/~shared/models/store.models';
import { SupportedLanguage } from '~core/models/shared.models';
import ApexFr from '../../../assets/apex-chart-locales/fr.json';
import { GpsCoordinates } from '../models/shared.models';
import { RoundingRule } from '~core/models/currency.models';

// State Constants
export const GLOBAL_STATE_TOKEN = new StateToken<GlobalStateModel>('global');
export const AUTH_STATE_TOKEN = new StateToken<AuthStateModel>('auth');
export const RESOURCE_STATE_TOKEN = new StateToken<ResourceStateModel>(
  'resource'
);
export const ESTABLISHMENT_STATE_TOKEN =
  new StateToken<EstablishmentStateModel>('establishment');

export const STICKER_CONSUMPTION_STATE_TOKEN =
  new StateToken<StickerConsumptionStateModel>('stickerConsumption');

export const INVOICE_STATE_TOKEN = new StateToken<InvoiceStateModel>('invoice');
export const DASHBOARD_STATE_TOKEN = new StateToken<DashboardStateModel>(
  'dashboard'
);

// Interceptors
export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(
  () => false
);
export const SKIP_JWT_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const SHOW_ERROR_INTERCEPTOR_FOR_401 = new HttpContextToken<boolean>(
  () => false
);

// i18n

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {
    languageCode: 'FR',
    fullLanguageCode: 'fr',
    flag: '/assets/images/fr_flag.svg',
    name: 'Français'
  },
  {
    languageCode: 'EN',
    fullLanguageCode: 'en',
    flag: '/assets/images/en_flag.svg',
    name: 'English'
  }
];

// Routes
export const LOGIN_PATH = '/sign-in';

// SCREEN BREAKPOINTS
export const TINY_SCREEN_BREAKPOINT = '(max-width: 767.98px)';
export const SMALL_SCREEN_BREAKPOINT =
  '(min-width: 768px) and (max-width: 991.98px)';
export const MEDIUM_SCREEN_BREAKPOINT =
  '(min-width: 992px) and (max-width: 1199.98px)';
export const DESKTOP_BREAKPOINT = '(min-width: 1280px)';
export const LARGE_SCREEN_BREAKPOINT =
  '(min-width: 1200px) and (max-width: 1399.98px)';
export const XLARGE_SCREEN_BREAKPOINT = '(min-width: 1400px)';

// Others
export const REMEMBER_ME_STATUS_KEY = 'auth_remember_me';

export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const ABIDJAN_GPS_COORDINATES: GpsCoordinates = {
  lat: 5.343924,
  lng: -4.0645722
};

export const APEX_CHART_LOCALES = [ApexFr];

export const SUPPORTED_IMAGE_FORMATS = '.png,.jpg,.jpeg, .webm';

export const ISO_UTC_OFFSET_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ';

export const roundingRules: Array<{ value: RoundingRule; name: string }> = [
  { value: 'rounded_down', name: 'Arrondi au plus proche (normal)' },
  {
    value: 'rounded_to_the_nearest_whole_number',
    name: 'Arrondi au plus grand (par excès)'
  },
  {
    value: 'rounded_to_the_nearest',
    name: 'Arrondi au plus petit (par défaut)'
  }
] as const;
